import { useCallback } from 'react'
import { HeaderWrapper, RightSection } from './style'
import HeaderRight from './header-right'
import Breadcrumb from './breadcrumb'
import { FunctionalErrorBoundary } from '@/shared/lib/error-boundary'
import RightSubMenu from './right-sub-menu'
import { useLocation } from 'react-router-dom'
import { useThemeStore, useThemeName } from '@/entities/theme/model'
import { darkTheme, classicTheme } from '../../theme'
import { setCookie } from '@/shared/lib/formatter'

interface Theme {
  themeName: string
  [key: string]: string
}

const themes: Record<string, Theme> = { dark: darkTheme, classic: classicTheme }

interface HeaderProps {
  isMainPages?: boolean
  isLogin?: boolean
}

const Header = ({ isMainPages, isLogin }: HeaderProps) => {
  const { pathname } = useLocation()
  const themeName = useThemeName()
  const isNotCredentialPath = pathname !== '/login'
  const isLoginPage = pathname === '/login'
  const isHome = pathname === '/'

  const toggleTheme = useCallback((newThemeName: string) => {
    const selectedTheme = themes[newThemeName] || darkTheme
    const { setTheme, setThemeName } = useThemeStore.getState()
    setTheme(selectedTheme)
    setThemeName(newThemeName)
    setCookie('themeName', newThemeName)
    setCookie('theme', JSON.stringify(selectedTheme))
  }, [])

  return (
    <HeaderWrapper
      isHome={isHome}
      isLoginPage={isLoginPage}
      isMainPages={isMainPages}
    >
      <RightSection>
        <HeaderRight>
          <div>
            <Breadcrumb />
          </div>
          {isNotCredentialPath && (
            <FunctionalErrorBoundary>
              <RightSubMenu
                toggleTheme={toggleTheme}
                themeName={themeName}
              />
            </FunctionalErrorBoundary>
          )}
        </HeaderRight>
      </RightSection>
    </HeaderWrapper>
  )
}

export default Header
